import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState, } from "react";
import { shouldDismissArticleReader } from "../domain/articles";
function publishedAtLabel(publishedAtUtc) {
    return new Intl.DateTimeFormat("en-US", {
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        month: "short",
        timeZone: "America/New_York",
        timeZoneName: "short",
        year: "numeric",
    }).format(new Date(publishedAtUtc));
}
export function ArticleReader({ article, articleId, onClose, }) {
    const closeButtonRef = useRef(null);
    const dragStartYRef = useRef(null);
    const dragOffsetRef = useRef(0);
    const [dragOffset, setDragOffset] = useState(0);
    useEffect(() => {
        closeButtonRef.current?.focus({ preventScroll: true });
        const onKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [onClose]);
    const finishDrag = () => {
        dragStartYRef.current = null;
        if (shouldDismissArticleReader(dragOffsetRef.current)) {
            onClose();
            return;
        }
        dragOffsetRef.current = 0;
        setDragOffset(0);
    };
    const titleId = `article-reader-title-${articleId}`;
    const dekId = `article-reader-dek-${articleId}`;
    const panelStyle = {
        "--article-reader-drag": `${dragOffset}px`,
    };
    return (_jsx("section", { "aria-describedby": article ? dekId : undefined, "aria-labelledby": titleId, "aria-modal": "true", className: "article-reader", "data-article-id": articleId, role: "dialog", children: _jsxs("div", { className: "article-reader__panel", "data-dragging": dragStartYRef.current !== null, style: panelStyle, children: [_jsxs("header", { className: "article-reader__chrome", children: [_jsx("div", { "aria-hidden": "true", className: "article-reader__drag-region", onPointerCancel: () => {
                                dragStartYRef.current = null;
                                dragOffsetRef.current = 0;
                                setDragOffset(0);
                            }, onPointerDown: (event) => {
                                if (event.button !== 0) {
                                    return;
                                }
                                dragStartYRef.current = event.clientY;
                                event.currentTarget.setPointerCapture(event.pointerId);
                            }, onPointerMove: (event) => {
                                if (dragStartYRef.current === null) {
                                    return;
                                }
                                const nextOffset = Math.max(0, event.clientY -
                                    dragStartYRef.current);
                                dragOffsetRef.current = nextOffset;
                                setDragOffset(nextOffset);
                            }, onPointerUp: finishDrag, children: _jsx("span", {}) }), _jsx("button", { ref: closeButtonRef, onClick: onClose, type: "button", children: "Done" })] }), article ? (_jsx("div", { "aria-label": "Article content", className: "article-reader__scroll", role: "region", tabIndex: 0, children: _jsxs("article", { className: "article-reader__article", children: [_jsxs("header", { className: "article-reader__header", children: [_jsx("p", { children: article.serviceLine }), _jsx("h1", { id: titleId, children: article.headline }), _jsx("p", { id: dekId, children: article.dek }), _jsxs("div", { className: "article-reader__meta", children: [article.byline ? (_jsxs("span", { children: ["By ", article.byline] })) : null, _jsx("time", { dateTime: article.publishedAtUtc, children: publishedAtLabel(article.publishedAtUtc) })] })] }), _jsx("div", { className: "article-reader__blocks", children: article.blocks.map((block, index) => {
                                    if (block.type === "heading") {
                                        return (_jsx("h2", { children: block.text }, `${index}-${block.text}`));
                                    }
                                    if (block.type === "paragraph") {
                                        return (_jsx("p", { children: block.text }, `${index}-${block.text}`));
                                    }
                                    return (_jsxs("figure", { className: `article-reader__image article-reader__image--${block.aspect.replace(":", "x")}`, children: [_jsx("div", { "aria-label": block.alt, role: "img" }), _jsx("figcaption", { children: block.caption })] }, block.id));
                                }) })] }) })) : (_jsxs("div", { className: "article-reader__unavailable", children: [_jsx("p", { children: "ARTICLE UNAVAILABLE" }), _jsx("h1", { id: titleId, children: "This article isn\u2019t available in the prototype." }), _jsx("p", { children: "Return to the feed and choose another item." })] }))] }) }));
}
